/** Cloud Function endpoint for the marketing intelligence agent. */
export const MARKETING_AGENT_ENDPOINT =
  'https://us-central1-lctf-projects.cloudfunctions.net/marketingAgentApi';

const GUIDE_URL = `${process.env.PUBLIC_URL || ''}/docs/settings/MARKETING_AGENT.md`;

function triggerMarkdownDownload(markdown: string, filename: string): void {
  const blob = new Blob([markdown], { type: 'text/markdown;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * Downloads the Marketing agent integration guide (served from public/docs).
 * Falls back to opening the guide in a new tab if fetch fails.
 */
export async function downloadMarketingAgentGuide(): Promise<void> {
  const date = new Date().toISOString().slice(0, 10);
  const filename = `marketing-agent-guide-${date}.md`;

  try {
    const res = await fetch(GUIDE_URL);
    if (res.ok) {
      const markdown = await res.text();
      triggerMarkdownDownload(markdown, filename);
      return;
    }
  } catch {
    /* fall through */
  }

  window.open(GUIDE_URL, '_blank', 'noopener,noreferrer');
}
